function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__hours-trained-1{fill:none;stroke-miterlimit:10;stroke-width:3.16px;stroke:#14345d}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "prefix__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.58,
  y: 1.58,
  width: 100,
  height: 100,
  rx: 20.83,
  stroke: "#f35f20",
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 3.16
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__hours-trained-1",
  d: "M51.58 7.83v8.33M51.58 87v8.33M95.33 51.58H87M16.16 51.58H7.83M24.5 51.58h29.16M51.58 53.66V37"
})));

var SvgTimeElapsed = function SvgTimeElapsed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 103.16 103.16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimeElapsed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time-elapsed.1456fab2.svg";
export { ForwardRef as ReactComponent };